import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";

import {
  Text,
  Flex,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Button,
  Textarea,
  RadioGroup,
  Stack,
  SimpleGrid,
  AbsoluteCenter,
  Center,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  useColorMode,
  useColorModeValue,
  Box,
    Editable,
    EditableInput,
    EditablePreview,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import CustomCheckbox from "../../../components/Checkbox/CustomCheckbox";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import axios from "axios";
import apiUrl from "variables/api";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const initialValues = {
  dateTime: "",
  location: "",
  transferPerson: "",
  transferItem: "",
  transferItemName: "",
  transferWarings: "",
  transferSeizing: "",
};

const validate = (values) => {
  const errors = {};

  if (!values.dateTime) {
    errors.dateTime = "Musisz podać datę i godzinę";
  }

  if (!values.location) {
    errors.location = "Musisz podać lokalizację";
  }

  if (!values.transferPerson) {
    errors.transferPerson = "Musisz wybrać cel przekazania";
  }

  if (!values.transferItem) {
    errors.transferItem = "Musisz wybrać co przekazujesz";
  }

  if (!values.transferItemName) {
    errors.transferItemName = "Musisz podać szczegóły przekazywanego obiektu";
  }

  if (!values.transferWarings) {
    errors.transferWarings = "Musisz podać uwagi dotyczące zabezpieczenia";
  }

  if (!values.transferSeizing) {
    errors.transferSeizing = "Musisz podać kto przejmuje";
  }

  return errors;
};

function Page() {
  const { colorMode } = useColorMode();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(apiUrl + '/data/vehicles', {
                    headers: { 'x-access-token': localStorage.getItem('token') }
                });
                const vehiclesData = response?.data;
                const formattedData = vehiclesData.reduce((acc, item) => {
                    const existingUnit = acc.find((unit) => unit.unit === item.unit);
                    if (existingUnit) {
                        existingUnit.vehicles.push(item.operationalNumber);
                    } else {
                        acc.push({ unit: item.unit, vehicles: [item.operationalNumber] });
                    }
                    return acc;
                }, []);
                console.log(formattedData);
                setData(formattedData);
            } catch (error) {
                console.error("Error fetching vehicles data:", error);
                toast.error("Błąd podczas pobierania danych pojazdów");
            }
        };

        fetchData();
    }, []);

const [data, setData] = useState([]);



useEffect(() => {
    const interval = setInterval(() => {
        console.log(data);
    }, 100000);

    return () => clearInterval(interval);
}, [data]);

const handleRemoveVehicle = (unitIndex, vehicleIndex) => {
    const newData = [...data];
    newData[unitIndex].vehicles.splice(vehicleIndex, 1);
    setData(newData);
    toast.success("Pojazd został usunięty");
};

const handleUpdateVehicle = (unitIndex, vehicleIndex, newValue) => {
    const newData = [...data];
    newData[unitIndex].vehicles[vehicleIndex] = newValue;
    setData(newData);
};

const handleDragEnd = (result) => {
    if (!result.destination) return;

    const { source, destination } = result;

    if (source.droppableId === destination.droppableId && source.index === destination.index) return;

    const newData = [...data];
    const [removed] = newData[source.droppableId].vehicles.splice(source.index, 1);
    newData[destination.droppableId].vehicles.splice(destination.index, 0, removed);

    setData(newData);
};

return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
        <Card minH="125px">
            <Flex direction="column">
                <Text fontWeight={"bold"} fontSize={"lg"}>
                    Zarządzanie wozami bojowymi
                </Text>
                <Box>
                    <DragDropContext onDragEnd={handleDragEnd}>
                        <Flex direction={"row"} gap={"40px"}>
                        {data.map((unit, unitIndex) => (
                            <Droppable droppableId={`${unitIndex}`} key={unitIndex}>
                                {(provided) => (
                                    <Box ref={provided.innerRef} {...provided.droppableProps}>
                                        <Flex alignItems="center">
                                            <Text>{unit.unit}</Text>
                                            <Button
                                                size="xs"
                                                colorScheme="green"
                                                ml="10px"
                                                onClick={() => {
                                                    const newData = [...data];
                                                    newData[unitIndex].vehicles.push("");
                                                    setData(newData);
                                                }}
                                            >
                                                +
                                            </Button>
                                        </Flex>
                                        <Flex direction={"column"} gap={"5px"} mb="20px">
                                            {unit.vehicles.map((vehicle, vehicleIndex) => (
                                                <Draggable key={vehicleIndex} draggableId={`${unitIndex}-${vehicle}`} index={vehicleIndex}>
                                                    {(provided) => (
                                                        <Box
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            position="relative"
                                                            display="flex"
                                                            alignItems="center"
                                                            onMouseEnter={(e) => {
                                                                const removeButton = e.currentTarget.querySelector(".remove-button");
                                                                if (removeButton) removeButton.style.display = "block";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                const removeButton = e.currentTarget.querySelector(".remove-button");
                                                                if (removeButton) removeButton.style.display = "none";
                                                            }}
                                                        >
                                                            <Box {...provided.dragHandleProps} mr="5px" cursor="grab">
                                                                &#x2630;
                                                            </Box>
                                                            <Input
                                                                value={vehicle}
                                                                onChange={(e) => handleUpdateVehicle(unitIndex, vehicleIndex, e.target.value)}
                                                                width="auto"
                                                                maxWidth="200px"
                                                            />
                                                            <Button
                                                                className="remove-button"
                                                                size="xs"
                                                                colorScheme="red"
                                                                ml="5px"
                                                                display="none"
                                                                onClick={() => handleRemoveVehicle(unitIndex, vehicleIndex)}
                                                            >
                                                                X
                                                            </Button>
                                                        </Box>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </Flex>
                                    </Box>
                                )}
                            </Droppable>
                        ))}
                        </Flex>
                    </DragDropContext>
                </Box>
                <Button
                    colorScheme="red"
                    mt="20px"
                    onClick={async () => {
                        try {
                            await axios.post(apiUrl + '/data/vehiclesUpdate', data, {
                                headers: { 'x-access-token': localStorage.getItem('token') }
                            });
                            toast.success("Dane zostały zapisane");
                        } catch (error) {
                            console.error("Error updating vehicles data:", error);
                            toast.error("Błąd podczas zapisywania danych");
                        }
                    }}
                >
                    Zapisz zmiany
                </Button>
            </Flex>
        </Card>
    </Flex>
);
}

export default Page;
